import { WEAPON_POWER } from "./weaponPower";

// Single source of truth for item prices. sellCatalog and prodVendingTables derive from this.
// A price of 0 means the item is not commercially tradeable.

export const WEAPON_POWER_TO_GOLD_FACTOR = 16;

function weaponPowerToPrice(power: number): number {
	return Math.ceil((power * WEAPON_POWER_TO_GOLD_FACTOR) / 2) * 2;
}

export function referencePriceToSellPrice(referencePrice: number): number {
	if (referencePrice <= 0) return 0;
	return Math.max(1, Math.trunc(referencePrice / 2));
}

export function getReferencePrice(key: string): number {
	return ITEM_REFERENCE_PRICES[key] ?? 0;
}

const weaponPrices = Object.fromEntries(
	Object.entries(WEAPON_POWER).map(([key, power]) => [key, weaponPowerToPrice(power)]),
);

export const ITEM_REFERENCE_PRICES: Record<string, number> = {
	...weaponPrices,
	Medikit: 200,
	Key: 200,
	Ammo: 1,
	Gold: 0,
	Jetpack: 300,
};
